import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Input,
  Button,
  Space,
  message,
  DatePicker
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
import moment from "moment";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";

const ParamEditModal = forwardRef(({ record, payFreqList, paramEditModalSubmitlFn}, ref) => {
    const [form] = Form.useForm();
    const [modalFlag, setModalFlag] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    
    useImperativeHandle(ref, () => ({
      openModal: () => {
        setModalFlag(true)
      }
    }));

    useEffect(() => {
      if(modalFlag){
        console.log(record, '====record');
        form.setFieldsValue({
          ...record,
          dueDate: record?.dueDate && dayjs(record?.dueDate) || null,
        })
      }
      return () => {
        setBtnLoading(false)
      }
    }, [modalFlag])

    const submitFn = async() => {
      setBtnLoading(true)
      const params = {
        ...form.getFieldsValue(),
        vendorUtilPaymentId: record.vendorUtilPaymentId,
        dueDate: form.getFieldsValue()?.dueDate?.format('YYYY-MM-DD') || '',
        dueDateStr: form.getFieldsValue()?.dueDate?.format('YYYY-MM-DD') || '',
      }
      const response = await http.post(api.UtilPaymentUpdateBy, params);
      if(response.code === '1'){
        message.success("Successfully Update.");
        setModalFlag(false)
        paramEditModalSubmitlFn(params)
      }else{
        message.warning("Failed update.");
      }
      setBtnLoading(false)
    }

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold"}}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          {`Account Number: ${record?.customerAccount || ''}`}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      destroyOnClose={true}
      width="40%"
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{span: 8}}
        wrapperCol={{span: 16}}
        labelWrap={true}
        labelAlign="right"
      >
        <Row gutter={[16, 16]}>
          <Col span={12} offset={6}>
            <Form.Item
              name="remark"
              label="Check Memo"
              rules={[{ required: true, message: 'Check Memo is required!' }]}
            >
              <Input 
                placeholder="Please input Check Memo"
              />
            </Form.Item>
            <Form.Item
              name="payFreq"
              label="Pay Freq"
              rules={[{ required: true, message: 'Pay Freq is required!' }]}
            >
              <Select
                placeholder="Select"
                style={{ width: "100%" }}
                options={payFreqList}
                popupMatchSelectWidth={false}
              />
            </Form.Item>
            <Form.Item
              name="dueDate"
              label="Due Date"
              rules={[{ required: true, message: 'Due Date is required!' }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format={['MM/DD/YYYY', "M/D/YYYY"]}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div style={{textAlign:'center'}}>
        <Space align="center">
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => submitFn()} loading={btnLoading}>
            Submit
          </Button>
        </Space>
      </div>
    </Modal>
    
  );
});

export default ParamEditModal;